import { Injectable, computed } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  static readonly MOBILE_BREAKPOINT: number = 768;

  private _isDesktop = toSignal(
    this.breakpointObserver
      .observe(`(min-width: ${LayoutService.MOBILE_BREAKPOINT}px)`)
      .pipe(map((result: BreakpointState): boolean => result.matches)),
    { initialValue: true },
  );

  public readonly isDesktop = computed(() => this._isDesktop() ?? true);
  public readonly isMobile = computed(() => !this.isDesktop());

  constructor(private breakpointObserver: BreakpointObserver) {}
}
